<template>
  <div>
    <div style="margin:0rem 0rem;padding: 0.5rem 0rem;background-color: white;"
      v-sticky="{ zIndex: 6, stickyTop: 56, className: 'sticky-buttons' }">
      <toggleFiltersJourney v-if="isToggleJourneyView" />
      <toggleFilters v-else />
    </div>
    <v-row v-if="!isToggleJourneyView" style="height: 75vh; z-index: 2">
      <v-col cols="12">
        <l-map ref="leafletmap" v-if="showMap&&center!=null" :zoom="zoom" :center="center" :options="mapOptions"
          @popupopen="setDirection(0,{'lat':coordinates.latitude,'lng':coordinates.longitude})"
          @popupclose="setDirection(1,null)" :class="showHeight==0 ? 'mapStoriesStyle' : 'mapStoriesStyleWithKeyboard'"
          style="height: 80vh; z-index: 2;overflow: hidden;position:absolute;bottom:0px" @update:center="centerUpdate"
          @update:zoom="zoomUpdate">
          <l-tile-layer :url="url" :visible="isLayerVisibile " />
          <l-tile-layer :url="url" :opacity="0.4" :visible="!isLayerVisibile" />
          <l-control class="mr-5" position="bottomright">
            <v-btn class=" mb-5" fab small @click="changeCenterOfTheMapToUserPosition()">
              <v-icon color="black">mdi-crosshairs-gps</v-icon>
            </v-btn>
          </l-control>
          <l-control class="mr-5" v-if="$store.getters.getUser.username!='Guest'" position="bottomright">
            <v-btn fab small :disabled="disabled==='true'?true:disabled=='false'?false:disabled" class=" mb-5"
              color="primaryVariant" @click="gotoCreateNewStoryContent()">
              <v-icon>mdi-pencil-plus</v-icon>
            </v-btn>
          </l-control>
          <l-control class="mr-5" v-if="(userLocation.lat!=null && userLocation.lng!=null && showDirection!=null)"
            position="bottomright">
            <v-btn class=" mb-5" @click="NavigateToDirection()" color="primaryVariant" style="transform: rotate(-90deg)"
              fab small block>
              <v-icon color="black">mdi-arrow-down-right-bold</v-icon>
            </v-btn>
          </l-control>
          <template v-if="getCurrentStories.length>0">
            <v-marker-cluster :options="{}">
              <l-marker v-for="(singleStories,i) in getCurrentStories"
                :lat-lng="{'lat':singleStories.latitude,'lng':singleStories.longitude}" :key="i+'_'+singleStories.id"
                @click="setCoordinatesStories(singleStories.latitude,singleStories.longitude,singleStories.id)">
                <l-icon :iconSize="[24, 24]" :iconAnchor="[12, 24]" :icon-url="require('@/assets/pinOnMap.png')"
                  :options="{ autoClose: false, closeOnClick: false }" />
                <l-popup :options="{ autoClose: false, closeOnClick: false }">
                  <span ref="markers">
                    <StoriesComponent :isMap="true" :singleStory="singleStories" :indexArrayOfStories="i"
                      :currentArrayOfStories="getCurrentStories" />
                  </span>
                </l-popup>
              </l-marker>
            </v-marker-cluster>
          </template>
          <!-- user position -->
          <l-marker v-if="userLocation.lng !=null && userLocation.lat!=null" :lat-lng="userLocation">
            <l-icon :con-size="[1,1]">
              <img style="width:5vh" :src="require('@/assets/account.png')" />
            </l-icon>
          </l-marker>
        </l-map>
      </v-col>
    </v-row>
    <!--map journey collection visualization--->
    <v-row v-else style="height: 75vh; z-index: 2">
      <v-col cols="12">
        <l-map ref="leafletmap" v-if="showMap&&center!=null" :zoom="zoom" :center="center" :options="mapOptions"
          @popupopen="setDirection(0,{'lat':coordinates.latitude,'lng':coordinates.longitude})"
          @popupclose="setDirection(1,null)" :class="showHeight==0 ? 'mapStoriesStyle' : 'mapStoriesStyleWithKeyboard'"
          style="height: 80vh; z-index: 2;overflow: hidden;position:absolute;bottom:0px" @update:center="centerUpdate"
          @update:zoom="zoomUpdate">
          <l-tile-layer :url="url" :visible="isLayerVisibile " />
          <l-tile-layer :url="url" :opacity="0.4" :visible="!isLayerVisibile" />
          <l-control class="mr-5" position="bottomright">
            <v-btn class=" mb-5" fab small @click="changeCenterOfTheMapToUserPosition()">
              <v-icon color="black">mdi-crosshairs-gps</v-icon>
            </v-btn>
          </l-control>
          <l-control class="mr-5" v-if="$store.getters.getUser.username!='Guest'" position="bottomright">
            <v-btn fab small :disabled="disabled==='true'?true:disabled=='false'?false:disabled" class=" mb-5"
              color="primaryVariant" @click="gotoCreateNewStoryContent()">
              <v-icon>mdi-pencil-plus</v-icon>
            </v-btn>
          </l-control>
          <l-control class="mr-5" v-if="(userLocation.lat!=null && userLocation.lng!=null&&showDirection!=null)"
            position="bottomright">
            <v-btn class=" mb-5" @click="NavigateToDirection()" color="primaryVariant" style="transform: rotate(-90deg)"
              fab small block>
              <v-icon color="black">mdi-arrow-down-right-bold</v-icon>
              <!--img style="width:6vh" :src="require('@/assets/direction2.png')" /-->
            </v-btn>
          </l-control>
          <template v-if="getCurrentStories.length>0">

            <l-polyline v-for="(item,i) in connectionLineJourney" :key="'connectionLineJourney '+i"
              :dashArray="item.dasharray" :lat-lngs="item.line" :weight="item.weight" :color="item.color"></l-polyline>
            <!--journey color background by group-->
            <span :options="{}" v-for="(singleJourney,i) in getCurrentStories" :key="i+'_'+singleJourney.id">
              <l-marker v-for="(singleStoryOfJourney,index) in singleJourney.storiesArrayObjectIdDescription"
                :key="index+'_'+singleStoryOfJourney.id"
                :lat-lng="{'lat':singleStoryOfJourney.latitude,'lng':singleStoryOfJourney.longitude}"
                @click="setCoordinatesJourney(singleStoryOfJourney.latitude , singleStoryOfJourney.longitude , singleStoryOfJourney.id ,singleJourney , singleStoryOfJourney)">
                <div class="text-center">
                  <l-icon :iconSize="[66, 66]" :iconAnchor="[33, 33]">
                    <div>
                      <v-img
                        v-if="singleStoryOfJourney.cover_image.media.formats==null||typeof singleStoryOfJourney.cover_image.media.formats=='undefined'"
                        class="coverImageStyle" :src="require('@/assets/placeholder.png')"></v-img>
                      <mediaFileStory v-else-if="singleStoryOfJourney.cover_image.media.formats.thumbnail"
                        class="coverImageStyle"
                        :mediaUrl="apiStrapi +'/uploads/'+ singleStoryOfJourney.cover_image.media.formats.thumbnail.hash + singleStoryOfJourney.cover_image.media.formats.thumbnail.ext"
                        :journeyBackgroundColor="singleJourney.backgroundColor" :isJourneyOrderNumber="index"
                        :journeyOrCollection="singleJourney.isJourney" :isMapRoundImg="true"
                        :type="singleStoryOfJourney.cover_image.type" />
                      <v-img v-else class="coverImageStyle" :src="require('@/assets/placeholder.png')"></v-img>
                    </div>
                  </l-icon>
                </div>
                <!--to change popup in dialog fullscreen-->
                <!--l-popup :options="{ autoClose: false, closeOnClick: false, fullscreen:true}">
                  <span ref="markers">
                    <StoriesComponent :journeyColorBackground="singleJourney.backgroundColor"
                      :isJourneyVisualization="true" :journeyBackgroundColor="singleJourney.backgroundColor"
                      :isMap="true" :singleStory="singleStoryOfJourney" :indexArrayOfStories="i"
                      :currentArrayOfStories="getCurrentStories"/>
                  </span>
                </l-popup-->
              </l-marker>
            </span>
          </template>
          <l-marker v-if="userLocation.lng !=null && userLocation.lat!=null" :lat-lng="userLocation">
            <l-icon :con-size="[1,1]">
              <img style="width:5vh" :src="require('@/assets/account.png')" />
            </l-icon>
          </l-marker>
        </l-map>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" style="width:100%;max-width:700px;margin-left:auto;margin-right:auto;background-color:#EEE">

      <v-card style="width:100%;max-width:700px;margin-left:auto;margin-right:auto">

        <v-card-actions>
          <v-spacer />
          <v-btn color="danger" text @click="closeDislogDetailStory()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>

        <v-card-text class="mx-0 px-0">
          <mediaFileStory  v-if="modalSingleStoryFromJourney.singleStoryOfJourney"
            :mediaUrl="apiStrapi +'/uploads/'+ modalSingleStoryFromJourney.singleStoryOfJourney.cover_image.media.formats.thumbnail.hash + modalSingleStoryFromJourney.singleStoryOfJourney.cover_image.media.formats.thumbnail.ext"
            :type="modalSingleStoryFromJourney.singleStoryOfJourney.cover_image.type" />
          <h2 class="mt-2 px-2" v-if="modalSingleStoryFromJourney.singleStoryOfJourney">
            {{modalSingleStoryFromJourney.singleStoryOfJourney.title}}</h2>
          <p class="mt-2 px-2" v-if="modalSingleStoryFromJourney.singleStoryOfJourney">
            {{modalSingleStoryFromJourney.singleStoryOfJourney.shortDescription}}</p>
          <v-card-actions>
            <v-spacer />
            <v-btn style="border-radius:999rem;border:2px solid #38737A;color:#38737A;text-transform:initial" @click="openSingleStoryDetail(modalSingleStoryFromJourney.singleStoryOfJourney.id)">
              {{$t('viewStory')}}
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
      <v-card outlined color="transparent" v-if="singleStoryDetail!=null" style="background-color:red;width:100%;max-width:700px;margin-left:auto;margin-right:auto;background-color:#EEE" > 

            <v-container  :style="'background-color:'+calcoulateLineColor(item.backgroundColor)"  class="mx-0 px-0 pt-0 mt-5 pb-0 mb-0" v-for="(item,index) in singleStoryDetail.stages" :key="index">
              <v-row align=center 
                class="mx-0 px-0 pt-0 mt-0 pb-0 mb-0">
                <v-col cols="6" class="mx-0 px-0 pt-0 mt-0 pb-0 mb-0">
                  <v-img v-if="item.cover_image.media.formats==null||typeof item.cover_image.media.formats=='undefined'"
                    class="coverImageStyle" :src="require('@/assets/placeholder.png')"></v-img>
                  <mediaFileStory v-else-if="item.cover_image.media.formats.thumbnail" class="coverImageStyle"
                    :mediaUrl="apiStrapi +'/uploads/'+ item.cover_image.media.formats.thumbnail.hash + item.cover_image.media.formats.thumbnail.ext"
                    :type="item.cover_image.type" />
                  <v-img v-else class="coverImageStyle" :src="require('@/assets/placeholder.png')"></v-img>
                </v-col>
                <v-col cols="6" class="mx-0 px-0 pt-0 mt-0 pb-0 mb-0">
                  <v-row>
                    <v-col cols=12>
                  <h4 class="mx-0 px-2 pt-0 mt-0 pb-0 mb-0 white--text">{{item.journeyTitle}}</h4>
                    </v-col>
                    <v-col cols=12 align=right>
                  <v-btn x-small class="btnShowJourney mr-2" :style="'color:'+calcoulateLineColor(item.backgroundColor)" @click="openSingleJourneyView(item.journey)">{{$t('viewJourneys')}}</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>



      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import VueSticky from 'vue-sticky' // Es6 module
import toggleFilters from "@/components/homeToggleFilters";
import toggleFiltersJourney from "@/components/homeToggleFiltersJourney";
import StoriesComponent from "@/components/storiesPreviewHome";
import {
  latLng
} from "leaflet";
import {
  LPolyline,
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  //  LTooltip,
  LIcon,
  LControl
} from "vue2-leaflet";
//import {EventBus} from "@/components/event-bus.js"
//import modalfilter from "@/components/modalFilter.vue";
import mediaFileStory from "@/components/mediaFileStory.vue";

import {
  mapState
} from 'vuex';

export default {

  name: "mapStories",
  directives: {
    'sticky': VueSticky,
  },
  components: {

    mediaFileStory,
    'v-marker-cluster': Vue2LeafletMarkerCluster,
    toggleFilters,
    toggleFiltersJourney,
    StoriesComponent,
    //    modalfilter,
    LPolyline,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    //   LTooltip,
    LIcon,
    LControl
  },
  data() {
    return {
    singleStoryDetail:null,
          swiperOption1: {
      slidesPerView: 1.1,
      spaceBetween: 0.5,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    },
    swiperOption2: {
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: '.swiper-pagination',
        clickable: false
      }
    },
      getJourneyConnectedToAStoryDictionary:[],
      dialog:false,
      apiStrapi: process.env.VUE_APP_ROOT_STRAPI,
      intervalBeweenMarkerClick: 0,
      disabled: process.env.VUE_APP_READONLY,
      iconSize: 30,
      showDirection: null,
      getUserCoordinates: null,
      isLayerVisibile: true,
      isLayer2Visibile: true,
      userLocation: {
        lat: 0,
        lng: 0
      },
      apiUrl: process.env.VUE_APP_ROOT_API,
      staticAnchor: [16, 37],
      zoom: 4,
      center: null,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      url2: 'https://api.maptiler.com/maps/outdoor/{z}/{x}/{y}.png	',
      currentZoom: 3,
      currentCenter: latLng(47.41322, -1.219482),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5
      },
      showMap: true,
      storiesList: [],
      filteredStoriesList: [],
      listOfFilterTag: [],
      searchPosition: null,
      //search city used in mvp 1
      //searchInput: "",
      isLoading: false,
      items: [],

      docmHeight: document.documentElement.clientHeight, // default screen visual height
      showHeight: 0, //body element height
      coordinates: {
        latitude: 0,
        longitude: 0
      },
      //      isShow: true, //Show or hide
      connectionLineJourney: [],
      modalSingleStoryFromJourney:{'singleJourney':null,'singleStoryOfJourney':null }
    };
  },
  mounted: async function () {
    //get the coordinates from device


    window.onresize = () => {
      return (() => {
        this.showHeight = document.body.clientHeight
      })()
    }

    //retrieves the position of all public stories saved in the db
    //await this.getStories()

    //check the current position of the user (for now it is associated with the user logged in the db)
    this.$getLocation()
      .then(response => {
        let coordinates = response
        if (coordinates != null && typeof coordinates != "undefined") {
          this.userLocation = {
            lat: coordinates.lat,
            lng: coordinates.lng
          }
        } else {
          if (this.getUserCoordinates != null) {
            this.userLocation = {
              lat: this.getUserCoordinates.lat,
              lng: this.getUserCoordinates.lng
            }
          }
        }
        this.center = this.userLocation
        // only for demo purpose - center the map on Europe
        this.center = {
          lat: 47.41322,
          lng: -1.219482
        }
      });
    //check the selected tag filters if any, filter the stories
    this.listOfFilterTag = this.$store.getters.getListOfSelectedTag
  },
      // Code that will run only after the
    // entire view has been re-rendered

  //get the reactive list of tags directly from vuex store
  computed: {
    isToggleJourneyView: {
      get: function () {
        return this.$store.getters.getIsJourneyOrSingleStory;
      }
    },
    navurl: {
      get() {
        if (this.userLocation.lat != null && this.userLocation.lng != null && this.showDirection != null) {
          return 'https://www.google.com/maps/dir/?api=1&origin=' + this.userLocation.lat + ',' + this.userLocation.lng + '&destination=' + this.showDirection.lat + ',' + this.showDirection.lng + '&travelmode=walking'
        } else return null
      }
    },
    dynamicSize: {
      get() {
        return [this.iconSize, this.iconSize * 1.15];
      }
    },
    dynamicAnchor: {
      get() {
        return [this.iconSize / 2, this.iconSize * 1.15];
      }
    },

    getCurrentStories: {
      get() {
        if (!this.$store.getters.getIsJourneyOrSingleStory) {
          if (!this.$store.getters.getIsCreatedOrviewStories) {
            if (!this.$store.getters.getIsSavedOrPublished) {
              return this.$store.getters.getCurrentUserStoriesDraft;
            } else {
              return this.$store.getters.getCurrentUserStoriesPublished;
            }
          } else {
            // to change
            if (!this.$store.getters.getIsAllOrNearme) {
              return this.$store.getters.getCurrentAllPublicStories;
            } else {
              return this.$store.getters.getCurrentAllPublicNearMeStories;
            }
          }
        } else {
          //Journey////////////////////////////////////////
          if (!this.$store.getters.getIsCreatedOrviewJourneys) {
            if (!this.$store.getters.getIsSavedOrPublishedJourneys) {
              return this.$store.getters.getCurrentUserJourneysDraft;
            } else {
              return this.$store.getters.getCurrentUserJourneysPublished;
            }
          } else {
            // to change
            if (!this.$store.getters.getIsAllOrNearmeJourneys) {
              return this.$store.getters.getCurrentAllPublicJourneys;
            } else {
              return this.$store.getters.getCurrentAllPublicNearMeJourneys;
            }
          }
        }
      }
    },
    ...mapState(['currentUserStoriesPublished', 'currentUserStoriesDraft', 'currentAllPublicNearMeStories', 'currentAllPublicStories', 'isCreatedOrviewStories', 'isAllOrNearme', 'isSavedOrPublished', 'listOfSelectedTag', 'currenUserStoryFilter', 'dialogFilterTag']),


  },
  watch: {
    //when i change the toggle or filter i reload the stories
    getCurrentStories: {
      handler() {

        this.showMap = false
        this.connectionLineJourney=[]
        this.getLines().then(() => this.showMap = true)


        this.showMap = true
      },
      deep: true
    },
    listenCurrentStoriesForChanges() {
      this.getCurrentStoriesSelectedByFilters()
    },
    searchPosition: function (value) {
      if (value == null || value.length < 4) {
        this.items = []
        return
      }
      //isLoading
      if (this.isLoading)
        return
      this.isLoading = true
      this.changeCenterOfTheMap(value).then(() => {
        this.isLoading = false
      })
    }
  },
  methods: {
closeDislogDetailStory:function(){
  this.dialog = false
  this.singleStoryDetail=null
},

    openSingleJourneyView: function (idJourney) {

        this.$router.push({
                'name': 'singleJourneyView',query: { idJourney: idJourney }
              })

    },
        openSingleStoryDetail: function (idOfSelectedStory) {
      //console.info("IDOftheStoryDetail",idOfSelectedStory,"array",this.currentArrayOfStories.slice(this.indexArrayOfStories).concat(this.currentArrayOfStories.slice(0,this.indexArrayOfStories)))

      // list of all stories for carousel array currentArrayOfStories
      // current index of array
        this.$store.dispatch('setSelectedSingleStoryID', idOfSelectedStory).then(
        this.$router.push({
                'name': 'carouselForSingleStoryView',query: { idStory: idOfSelectedStory }
              })
        //dispatch story id in the store
      )
    },
    getJourneyFromIdStory(idSelectedStory){
        let arrayOfJourneys=[]
        console.log(idSelectedStory,this.getCurrentStories)
        this.getCurrentStories.forEach((element)=>{
        console.log(element)
        })
        return arrayOfJourneys
      },
    calcoulateLineColor(colorNumber) {

      if (colorNumber == 1) {
        return this.$vuetify.theme.themes.light.colorPalettejourney1
      } else if (colorNumber == 2) {
        return this.$vuetify.theme.themes.light.colorPalettejourney2
      } else if (colorNumber == 3) {
        return this.$vuetify.theme.themes.light.colorPalettejourney3
      } else if (colorNumber == 4) {
        return this.$vuetify.theme.themes.light.colorPalettejourney4
      } else if (colorNumber == 5) {
        return this.$vuetify.theme.themes.light.colorPalettejourney5
      } else if (colorNumber == 6) {
        return this.$vuetify.theme.themes.light.colorPalettejourney6
      } else
        return 'grey'
    },
    //to do calculate all the journeys line
    async getLines() {
      this.showMap = false
      this.connectionLineJourney = []
      this.getCurrentStories.forEach(elementJourney => {

        if (elementJourney.isJourney) {

          elementJourney.storiesArrayObjectIdDescription.forEach((elementstory, index) => {

            if (index < elementJourney.storiesArrayObjectIdDescription.length - 1)

              this.connectionLineJourney.push({
                line: [latLng(elementstory.latitude, elementstory.longitude), latLng(elementJourney.storiesArrayObjectIdDescription[index + 1].latitude, elementJourney.storiesArrayObjectIdDescription[index + 1].longitude)],
                color: this.calcoulateLineColor(elementJourney.backgroundColor),
                weight: 12,
                opacity: 0.5,
                smoothFactor: 1
              })
          })
        }
      })
    },
    loadPhoto(value) {
      return value
    },
    log: function () {},
    NavigateToDirection() {
      console.log('clicked', 'https://www.google.com/maps/dir/?api=1&origin=' + this.userLocation.lat + ',' + this.userLocation.lng + '&destination=' + this.showDirection.lat + ',' + this.showDirection.lng + '&travelmode=walking')
      window.open('https://www.google.com/maps/dir/?api=1&origin=' + this.userLocation.lat + ',' + this.userLocation.lng + '&destination=' + this.showDirection.lat + ',' + this.showDirection.lng + '&travelmode=walking', '_blank');
    },
    setCoordinatesStories: function (lat, long, id) {

      //save the coordinates for direction button
      this.showDirection = this.center
      //set new center and zoom in when press a marker on the map
      //this.$refs.leafletmap.mapObject.setView(latLng(lat,long), 14)
      this.coordinates.latitude = lat
      this.coordinates.longitude = long
      this.coordinates.id = id

    },
        async getSingleStory(selectedStoryDetailID) {
      try {


        this.$store.dispatch('setLoading', true)
        let completeurl = this.apiUrl + '/getSingleStory?id=' + selectedStoryDetailID
        let tempSingleStoryDetail
        tempSingleStoryDetail = await this.getaxiosResponse(completeurl)
        if (typeof tempSingleStoryDetail.content == "string") {
          tempSingleStoryDetail.content = JSON.parse(tempSingleStoryDetail.content)
        }
        this.singleStoryDetail = tempSingleStoryDetail.data

        this.$store.dispatch('setLoading', false)
if (tempSingleStoryDetail==null){
  console.log('you do not have the correct credentials to view the story')
        this.$router.push({
          name: 'errorPage'
        })
}
      } catch (error) {
        console.log(error);
        this.$router.push({
          name: 'errorPage'
        })
      }
    },
    /** To delete */
    calculateCurrentJourneyConnectedToStory(){
        this.getJourneyConnectedToAStoryDictionary=[]
this.getCurrentStories.forEach(singlejourney=>{
    singlejourney.storiesArrayObjectIdDescription.forEach(singleStory=>{
      this.getJourneyConnectedToAStoryDictionary[singleStory.id]=singlejourney})
})
    },


//setCoordinates(singleStoryOfJourney.latitude,singleStoryOfJourney.longitude,singleStoryOfJourney.id,item,singleJourney,singleStoryOfJourney)
    setCoordinatesJourney: function (lat, long, id,singleJourney,singleStoryOfJourney) {
      this.getSingleStory(singleStoryOfJourney.id)
//this.openSingleStoryDetail(modalSingleStoryFromJourney.singleStoryOfJourney.id)
      this.dialog = true
      this.modalSingleStoryFromJourney.singleJourney = singleJourney

      this.modalSingleStoryFromJourney.singleStoryOfJourney = singleStoryOfJourney

      //set the new center on selected marker
      this.center = {
        lat: lat,
        lng: long
      }
      //save the coordinates for direction button
      this.showDirection = this.center
      //set new center and zoom in when press a marker on the map
      //this.$refs.leafletmap.mapObject.setView(latLng(lat,long), 14)
      this.coordinates.latitude = lat
      this.coordinates.longitude = long
      this.coordinates.id = id

    },

    setDirection: function (action, directions) {
      if (directions==null){
        this.modalSingleStoryFromJourney==null
      }

      this.intervalBeweenMarkerClick = Math.floor(Date.now() / 1000)

      /*fix to avoid double click too short when press marker*/
      if (Math.abs(Math.floor(Date.now() / 1000) - this.intervalBeweenMarkerClick) > 10) {
        console.log("Math.abs(Math.floor(Date.now() / 1000)-this.intervalBeweenMarkerClick)", Math.abs(Math.floor(Date.now() / 1000) - this.intervalBeweenMarkerClick))
        this.intervalBeweenMarkerClick = Math.abs(Math.floor(Date.now() / 1000))
        this.showDirection = directions

      }
    },
    gotopage: function (page) {
      if (this.$route.name != page) {
        this.$router.push({
          'name': page
        })
      }
    },
    retriveDataLocation: async function (searchLocation) {
      try {
        return this.getaxiosResponse(this.apiUrl + "/getLocations?place=" + searchLocation)
      } catch (error) {
        if (error.status === 400) {
          //EventBus.$emit("spinner", "off");
        }
        // Handle error.
        else {

          console.log(error);
        }
      }
    },
    gotoCreateNewStoryContent: function () {
      this.$store.dispatch("clearNewStory").then(() => {
        this.$router.push({
          'name': 'createNewStoryContent'
        })
      })
    },
    // center the map to user position
    changeCenterOfTheMapToUserPosition: function () {
      this.$refs.leafletmap.mapObject.setView(latLng(this.userLocation.lat, this.userLocation.lng), 11)
    },
    //when i change te place i have to center the map in the new position
    changeCenterOfTheMap: async function (searchLocation) {
      try {
        let response = await this.retriveDataLocation(searchLocation)
        this.items = response.data
        this.currentZoom = 11.5
      } catch (error) {
        if (error.status === 400) {
          //EventBus.$emit("spinner", "off");
        }
        // Handle error.
        else {
          //EventBus.$emit("spinner", "off");
          console.log(error);
        }
      }
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    }
  }
};
</script>

<style>
 /* Hide scrollbar for Chrome, Safari and Opera */
.example::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.example {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";

.leaflet-container a.leaflet-popup-close-button{
  top: 6%;
  color:red!important;
  font-size: 2rem;
  width: 2rem;
}
.leaflet-popup-content{
margin: 0px -2px;
}
.leaflet-top .leaflet-control{
  margin-top:3vh;
}

.leaflet-bottom-left{
  bottom:0px;
  left:0px;
}
.leaflet-center {
    left: 50%;
    transform: translate(-50%, 0%);
}

.leaflet-middle {
    top: 50%;
    position: absolute;
    z-index: 1000;
    pointer-events: none;
  transform: translate(0%, -50%);

}

.leaflet-center.leaflet-middle {
  transform: translate(-50%, -50%);
}

.leaflet-bottom .leaflet-control{
  margin-bottom: 0px;
  margin-right: 0px;
}

/** iphone X **/
@media only screen
    and (device-width : 375px)
    and (device-height : 812px)
    and (-webkit-device-pixel-ratio : 3) { }

/** iphone 8 **/
@media only screen
    and (device-width : 375px)
    and (device-height : 667px) {
      .mapStoriesStyle{
        max-height: 70vh;

      }
      .mapStoriesStyleWithKeyboard{
          /*max-height: 5vh;*/
}
    }

/** iphone 8 Plus**/
@media only screen
    and (device-width : 414px)
    and (device-height : 736px) {
      .mapStoriesStyle{
        max-height: 70vh;

      }
            .mapStoriesStyleWithKeyboard{
              /*bottom: -10vh;*/
              }
     }

/* samsung edge 7*/
@media only screen
    and (device-width : 360px)
    and (device-height : 640px){
      .mapStoriesStyle{
        max-height: 70vh ;

      }
            .mapStoriesStyleWithKeyboard{
          /*max-height: 5vh;
              bottom: -10vh;*/

}
    }
/* samsung s9 plus*/
@media only screen
    and (device-width : 360px)
    and (device-height : 740px){
      .mapStoriesStyle{
        max-height: 70vh ;
      }
            .mapStoriesStyleWithKeyboard{
          /*max-height: 5vh;
              bottom: -10vh;*/

}
    }


    .square {
      border-radius:5%;
      border:2px solid black;
min-width: 20vh;
min-height: 20vh;
word-wrap: break-word;
  background-color: #888;
}
.circle {
  height: 5vh;
  width: 5vh;
  background-color: #555;
  border-radius: 50%;
}
.btnShowJourney{
  text-transform: initial;
border-radius: 999rem;
padding: 2% 4%;
font-size: 0.8rem;
}
</style>
